export default "__VITE_ASSET__0e892b14__"